import ManagerHttp from './managerHttp';
import { urlParamsToObject } from '../utils/url';
import { OP_WRAPPER_LOCALIZATION_PREFIX } from '../utils/constants';

export default class ManagerGameRequests {
  constructor({ api, sid, gid, cheatsParams, developmentGetSessionPath, baseData, handleWinLimits = true }) {
    this.api = api;
    this.sid = sid;
    this.gid = gid;
    this._baseData = baseData;
    this._cheatsParams = cheatsParams;
    this._developmentGetSessionPath = developmentGetSessionPath;
    this._handleWinLimits = handleWinLimits;

    this.adress = window.location.origin;
    if (this._developmentGetSessionPath) this._tryGetSessionForDev();
  }

  async sendGameInitRequest(data, doNotInitWrapperFreebets = false) {
    const response = await this.sendGameRequest(data, `game_init`);
    await window.OPWrapperService.init({
      partnerConfig: response.partner_config,
      language: response.lang,
      region: response.region,
      tournaments: response.tournaments,
      currencyInfo: {
        currency: response.currency,
        decimals: response.decimals,
      },
    });
    if (!doNotInitWrapperFreebets) window.OPWrapperService.freeBetsController.setData(response.freebets);
    return response;
  }

  async sendGameRequest(data = {}, urlPath = 'game_request') {
    data = {
      ...this._baseData,
      ...data
    };
    this._trySendCheatParams(data);
    let url = `https://${ManagerHttp.api}/${urlPath}?sid=${ManagerHttp.sid}&gid=${ManagerHttp.gid}`;
    const retryCount = ['game_init', 'config'].includes(data.id) ? 2 : 0;
    try {
      return await ManagerHttp.postRequest(url, data, {}, retryCount).then(response => {
        if (data.id !== 'game_init') this._saveServerResponse(response);
        if (data.id === 'config') window.OPWrapperService.SystemUI.updateBalanceInfo(response.balance);
        if (response.isWinLimitReached && this._handleWinLimits) window.OPWrapperService.SystemUI.handleWinLimits();
        return response;
      });
    } catch (error) {
      if (error.hasOwnProperty('success') && !error.success) {
        window.OPWrapperService.showError(error.code, error.message, error.isReload);
      } else {
        console.error(error);
        window.OPWrapperService.showError(window.OPWrapperService.errors.REQUEST_FAILED.CODE);
      }
    }
  }

  _saveServerResponse(response) {
    const responsesCountToStore = 2; // need to store at least 2 to display last win correctly in case of win limit exceeded
    window.OPWrapperService.model.update(prev => {
      const serverResponses = [
        ...prev.serverResponses,
        {
          balance: response.balance,
          isWinLimitReached: response.isWinLimitReached || false,
          winLimit: response.maxWinLimitCurrency || null
        }
      ];
      if (serverResponses.length > responsesCountToStore) serverResponses.shift();
      return {
        ...prev,
        serverResponses
      }
    })
  }

  _tryGetSessionForDev() {
    const devEnvironments = [/localhost/, /0\.0\.0\.0/, /192\.168\./];
    if (devEnvironments.some(regexp => regexp.test(this.adress))) {
      const queryParams = urlParamsToObject(new URLSearchParams(window.location.search));
      if (!Object.keys(queryParams).length) {
        this._getSession();
      }
      this.adress = `https://${this.api}/`
    } else if (/192.168/.test(this.adress)) {
      this.adress = ''
    } else {
      this.adress = window.location.protocol + '//' + this.api + '/';
    }
  }

  async _getSession() {
    try {
      const developmentGetSessionPath = this._developmentGetSessionPath.replace('&no_redirect', '').replace('&no_op_launcher', ''); //hack for old games with &no_redirect&no_op_launcher queries
      const raw = await fetch(developmentGetSessionPath, { //
        method: 'GET',
      });
      if (raw.url) {
        const searchParams = raw.url.split('?')[1];
        window.location = `${window.location.origin}?${searchParams}`;
      }
    } catch (e) {
      console.error(e);
    }
  }

  _trySendCheatParams(data) {
    if (!this._cheatsParams) return;
    const forceChainCheatName = 'force_chain'
    for (const cheatsParam of this._cheatsParams) {
      if (window.hasOwnProperty(cheatsParam) || (window.hasOwnProperty(forceChainCheatName) && window[forceChainCheatName].hasOwnProperty(cheatsParam) && data.id === 'spin')) {
        data[cheatsParam] = window.hasOwnProperty(cheatsParam) ? window[cheatsParam] : window[forceChainCheatName][cheatsParam].shift();
        delete window[cheatsParam];
      }
    }
  }
}
